// Re-usable form heading component so that the headings are consistent
const FormHeading = ({ children }) => (
    <h1 className="text-3xl">
        {children}
    </h1>
)

export default FormHeading;